import styled from 'styled-components';

import { LocaleLink } from '@/utils/locale';

import { media } from '../../../utils/mediaQueries';

export const BreadcrumbsContainer = styled.div`
    padding: 0;

    ${media.tabletDown} {
        display: none;
    }
`;

export const Container = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
`;

export const BreadcrumbLink = styled(LocaleLink)<{ $isHome?: boolean }>`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
    text-decoration: none;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border-radius: 6px;

    svg {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4b5563')};
    }

    &:hover {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
        background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};

        svg {
            color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
        }
    }
`;

export const BreadcrumbText = styled.span<{ $isActive?: boolean; $isDisabled?: boolean }>`
    font-size: 13px;
    font-weight: 400;
    color: ${({ $isDisabled, $isActive, theme }) => {
    if ($isDisabled) return theme.mode === 'dark' ? '#6b7280' : '#9ca3af';
    if ($isActive) return theme.mode === 'dark' ? '#f9fafb' : '#111827';
    return theme.mode === 'dark' ? '#e5e7eb' : '#374151';
  }};
    padding: 4px 8px;

    ${(props) => props.$isDisabled && `
        font-style: italic;
        cursor: default;
        user-select: none;
    `}
`;

export const ExpandButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e5e7eb')};
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e5e7eb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#d1d5db')};
        color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
    }

    &:active {
        transform: scale(0.95);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;
